import { Box, Popover } from '@mui/material';
import React from 'react';
import { HexColorInput, HexColorPicker } from 'react-colorful';

export const ColorPicker = ({
  color,
  onChange,
}: {
  color: string;
  onChange: (color: string) => void;
}) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLDivElement | null>(null);
  return (
    <>
      <Box
        className="swatch"
        sx={{
          backgroundColor: color,
          width: '90px',
          height: '28px',
          borderRadius: '8px',
          border: '1px solid black',
          cursor: 'pointer',
        }}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      />
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{ sx: { overflow: 'visible' } }}
        sx={{
          borderRadius: '9px',
          boxShadow: '0 6px 12px rgba(0, 0, 0, 0.15)',
        }}
      >
        <HexColorPicker color={color} onChange={onChange} />
        <HexColorInput
          style={{ border: 'none', textAlign: 'center', width: '100%' }}
          prefixed
          color={color}
          onChange={onChange}
        />
      </Popover>
    </>
  );
};
